<script>
  // the hook for supplied props
  export let data;

  // figure out all the unique counties we have and sort them
  const availableCounties = Array.from(
    new Set(data.map((d) => d.county))
  ).sort();

  // our constant for limiting
  const limit = 10;

  // values
  let selectedCounty = 'Los Angeles';
  let showAll = false;

  // computed values
  $: selectedCounties = data.filter((d) => d.county === selectedCounty);
  $: filteredCounties = selectedCounties;
  $: enoughCounties = filteredCounties.length > limit;

  const random = (length = 8) => {
    return Math.random().toString(16).substr(2, length);
  };
  const id = random(6);

  // to make it less confusing we always reset our show all on county change
  function onChange() {
    document.getElementById(`nursinghomes-table-input-${id}`).value = '';
    showAll = false;
  }

  // flip the toggle on each click
  function onToggle() {
    showAll = !showAll;
  }

  // Filter table
  function filterRows(e) {
    showAll = false;
    const value = e.target.value.toUpperCase();
    if (value == '') {
      filteredCounties = selectedCounties;
    } else {
      filteredCounties = selectedCounties.filter(
        (d) => d.name.toUpperCase().indexOf(value) > -1
      );
    }
  }
</script>

<div>
  <div class="dg-table--inputs button-grid">
    <div class="button-grid-group">
      <label for="nursing-home-county-select-{id}">Filter by county</label>
      <select
        name="counties"
        id="nursing-home-county-select-{id}"
        bind:value={selectedCounty}
        on:blur={onChange}
      >
        {#each availableCounties as county}
          <option value={county}>{county}</option>
        {/each}
      </select>
    </div>
    <div class="button-grid-group">
      <label for="nursinghomes-table-input-{id}">Search by name</label>
      <input
        class="search"
        style="display: block;"
        id="nursinghomes-table-input-{id}"
        on:keyup={filterRows}
      />
    </div>
  </div>
  <table class="dg-table">
    <thead>
      <tr class="topper">
        <th scope="col" colspan="1" class="no-border" />
        <th scope="col" colspan="2" class="text-center left-border no-border"
          >Residents</th
        >
        <th scope="col" colspan="2" class="text-center left-border no-border"
          >Staff</th
        >
      </tr>
      <tr>
        <th scope="col" class="text-left">Facility</th>
        <th scope="col" class="text-right left-border">Cases</th>
        <th scope="col" class="text-right">Deaths</th>
        <th scope="col" class="text-right left-border">Cases</th>
        <th scope="col" class="text-right">Deaths</th>
      </tr>
    </thead>
    <tbody>
      {#each filteredCounties as obj, idx}
        <tr class:display-none={enoughCounties && idx + 1 > limit && !showAll}>
          <th scope="row" class="text-left">{obj.name.toUpperCase()}</th>
          <td class="text-right">
            {obj.patients_confirmed_cases_note
              ? obj.patients_confirmed_cases_note
              : obj.patients_confirmed_cases || '-'}
          </td>
          <td class="text-right">
            {obj.patients_deaths_note
              ? obj.patients_deaths_note
              : obj.patients_deaths || '-'}
          </td>
          <td class="text-right">
            {obj.staff_confirmed_cases_note
              ? obj.staff_confirmed_cases_note
              : obj.staff_confirmed_cases || '-'}
          </td>
          <td class="text-right">
            {obj.staff_deaths_note
              ? obj.staff_deaths_note
              : obj.staff_deaths || '-'}
          </td>
        </tr>
      {/each}
    </tbody>
  </table>
  <div class="text-center">
    {#if enoughCounties}
      <button class="btn" on:click={onToggle}>
        {showAll ? 'Show less' : 'Show all'}
      </button>
    {/if}
  </div>
</div>
